var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 57.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 49.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 41.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref24 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref26 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 33.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref33 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 25.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 17.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 9,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 17,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 25,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 33,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 41,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 49,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 9.5,
  y: 57,
  width: 6,
  height: 6,
  fill: "#DAEBF1"
});
var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 11L36.5 36L61.5 11",
  stroke: "#B5D7E3",
  strokeWidth: 4
});
var _ref52 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.5,
  cy: 36,
  r: 9,
  fill: "#F9FCFD",
  stroke: "#B5D7E3",
  strokeWidth: 4
});
var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 33.5C40.5 34.3284 39.8284 35 39 35C38.1716 35 37.5 34.3284 37.5 33.5C37.5 32.6716 38.1716 32 39 32C39.8284 32 40.5 32.6716 40.5 33.5Z",
  fill: "#B5D7E3"
});
var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 33.5C35.5 34.3284 34.8284 35 34 35C33.1716 35 32.5 34.3284 32.5 33.5C32.5 32.6716 33.1716 32 34 32C34.8284 32 35.5 32.6716 35.5 33.5Z",
  fill: "#B5D7E3"
});
var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M36.5 37.5C33.7179 37.5 32.2792 38.0757 31.7469 38.3535C31.612 38.4239 31.6033 38.5882 31.7343 38.6655C32.2162 38.9497 33.5326 39.5 36.5 39.5C39.4674 39.5 40.7838 38.9497 41.2657 38.6655C41.3967 38.5882 41.388 38.4239 41.2531 38.3535C40.7208 38.0757 39.282 37.5 36.5 37.5Z",
  fill: "#B5D7E3"
});
var _ref56 = /*#__PURE__*/React.createElement("circle", {
  cx: 61.5,
  cy: 11,
  r: 9,
  fill: "#F9FCFD",
  stroke: "#B5D7E3",
  strokeWidth: 4
});
var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M65.5 8.5C65.5 9.32843 64.8284 9.5 64 9.5C63.1716 9.5 62.5 9.32843 62.5 8.5C62.5 7.67157 63.1716 7 64 7C64.8284 7 65.5 7.67157 65.5 8.5Z",
  fill: "#B5D7E3"
});
var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M60.5 8.5C60.5 9.32843 59.8284 9.5 59 9.5C58.1716 9.5 57.5 9.32843 57.5 8.5C57.5 7.67157 58.1716 7 59 7C59.8284 7 60.5 7.67157 60.5 8.5Z",
  fill: "#B5D7E3"
});
var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M61.5 13.5C59.4964 13.5 57.8909 12.7535 56.8467 12.0763C56.6045 11.9193 56.2881 12.2027 56.4734 12.424C57.4356 13.5733 59.1111 15 61.5 15C63.8889 15 65.5644 13.5733 66.5266 12.424C66.7119 12.2027 66.3955 11.9193 66.1533 12.0763C65.1091 12.7535 63.5036 13.5 61.5 13.5Z",
  fill: "#B5D7E3"
});
var _ref60 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 11,
  r: 9,
  fill: "#F9FCFD",
  stroke: "#B5D7E3",
  strokeWidth: 4
});
var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 8.5C15.5 9.32843 14.8284 9.5 14 9.5C13.1716 9.5 12.5 9.32843 12.5 8.5C12.5 7.67157 13.1716 7 14 7C14.8284 7 15.5 7.67157 15.5 8.5Z",
  fill: "#B5D7E3"
});
var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 8.5C10.5 9.32843 9.82843 9.5 9 9.5C8.17157 9.5 7.5 9.32843 7.5 8.5C7.5 7.67157 8.17157 7 9 7C9.82843 7 10.5 7.67157 10.5 8.5Z",
  fill: "#B5D7E3"
});
var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 13.5C9.49636 13.5 7.89087 12.7535 6.84668 12.0763C6.60455 11.9193 6.28812 12.2027 6.47337 12.424C7.43556 13.5733 9.11111 15 11.5 15C13.8889 15 15.5644 13.5733 16.5266 12.424C16.7119 12.2027 16.3955 11.9193 16.1533 12.0763C15.1091 12.7535 13.5036 13.5 11.5 13.5Z",
  fill: "#B5D7E3"
});
function SvgIllustrationHighMidHigh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHighMidHigh);
export default __webpack_public_path__ + "static/media/illustration-high-mid-high.626744a3efc60d0715ebca5892b52daa.svg";
export { ForwardRef as ReactComponent };